export default {
  title: 'Tietojen poistopyynnöt',
  fields: {
    created_at: 'Pyydetty',
    restaurant: 'Ravintola',
    customer: 'Asiakas',
    note: 'Huomautus',
    status: 'Tila',
    completed_by: 'Suoritti',
    actions: 'Toiminnot',
  },
  statuses: {
    pending: 'Odottaa',
    completed: 'Valmis',
  },
  buttons: {
    approve: 'Hyväksy',
  },
  modals: {
    approve: {
      title: 'Hyväksytäänkö tietojen poisto käyttäjälle {{name}}?',
      description: 'Tämä poistaa asiakkaan henkilötiedot pysyvästi eikä sitä voi perua. Pyyntö merkitään suoritetuksi.',
    },
  },
  toasts: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
    failed_to_approve: 'Pyynnön hyväksyminen epäonnistui',
    approved: 'Pyyntö hyväksytty ja tiedot poistettu',
  },
};
